export function numberToPercentString(
  totalPercentChange: number,
  decimals: number = 2
): string {
  return `${(totalPercentChange * 100).toFixed(decimals)}%`;
}
